import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Table,
  Button,
  FormGroup,
  CardBody,
  Label,
  Input,
} from "reactstrap";
import PageTitle from "../../components/PageTitle";
import { connect } from "react-redux";
import styled from "styled-components";
import PageBody from "../../components/PageBody";
import ToggleButton from "../../common/ToggleButton";
import ModalPopup from "../../components/ModalPopup";
import { Loader } from "react-feather";
import { baseUrl } from "../../constants/environment";
import APIClient from "../../helpers/APIClient";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import RowEmpty from "../../components/RowEmpty";
import { useHistory } from "react-router";
import NumberFormat from "react-number-format";
import TextUtils from "../../helpers/TextUtils";
import IconCheckbox from "../../assets/images/icon-checkbox.png";
import IconCheckboxActive from "../../assets/images/icon-checkbox-active.png";
import IconTooltip from "../../assets/images/icon-tooltip.png";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import { ValueText } from "../product/ProductAdd";
import PriceUtils from "../../helpers/PriceUtils";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
interface Props {
  history: any;
  location: any;
  match: any;
  user: any;
}

const RankConfig: React.FC<Props> = (props: any) => {
  const { user } = props;
  const router = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    status: 0,
  });
  const [dataLine, setDataLine] = useState<any>([]);
  const [history, setHistory] = useState<any>();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<any>({});

  useEffect(() => {
    document.title = "Phân hạng thành viên";
    loadData();
  }, []);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target;
    if (value === " ") return;
    setData({
      ...data,
      [name]: value,
    });
  };

  const loadData = async () => {
    setLoading(true);
    const url = `${baseUrl}/customer-rank-config`;
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error);
    } else if (response.response !== undefined) {
      setData(response?.response);
      setDataLine(response?.response?.customer_rank_config_lines);
    }
    loadHistory();
  };

  const loadHistory = async () => {
    const url = `${baseUrl}/customer-rank-config/history`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = response.response?.data;
      setHistory(resData);
    }
  };

  const validationFrom = () => {
    if (!data?.review_cycle_day) {
      toast.warning("Chu kì xét hạng thành viên (ngày) không được để trống!");
      return false;
    }
    if (!data?.rank_type) {
      toast.warning("Loại điều kiện xếp hạng không được để trống!");
      return false;
    }
    if (
      (data?.receipts_group === "supplier" ||
        data?.receipts_group === "customer") &&
      data?.source_code?.length === 0
    ) {
      toast.warning("Mã chứng từ gốc không được để trống!");
      return false;
    }
    if (dataLine?.length === 0) {
      toast.warning("Cấp bậc xếp hạng thành viên không được để trống!");
      return false;
    }

    const checkLine = dataLine?.reduce((prev: any, item: any) => {
      if (!item?.rank_name) {
        prev = false;
      }
      return prev;
    }, true);
    if (!checkLine) {
      toast.warning("Tên hạng thành viên không được đẻ trống");
      return false;
    }

    const valueLineArr = dataLine?.map(function (item: any) {
      return item.rank_name;
    });
    const isDuplicateLine = valueLineArr.some(function (item: any, idx: any) {
      return valueLineArr.indexOf(item) != idx;
    });
    if (isDuplicateLine) {
      toast.warning("Tên hạng thành viên không thể trùng nhau");
      return false;
    }
    if (data?.rank_type === "or") {
      const valueLineCountArr = dataLine?.map(function (item: any) {
        return item.bill_number;
      });
      const isDuplicateLineCount = valueLineCountArr.some(function (
        item: any,
        idx: any
      ) {
        return valueLineCountArr.indexOf(item) != idx;
      });
      const valueLineTotalArr = dataLine?.map(function (item: any) {
        return item.bill_total;
      });
      const isDuplicateLineTotal = valueLineTotalArr.some(function (
        item: any,
        idx: any
      ) {
        return valueLineTotalArr.indexOf(item) != idx;
      });
      //nếu là hoặc thì các thông số không được trùng nhau
      if (isDuplicateLineCount) {
        toast.warning(
          "Với loại điều kiện xếp hạng là hoặc thì Số lượng hoá đơn không thể trùng nhau"
        );
        return false;
      }
      if (isDuplicateLineTotal) {
        toast.warning(
          "Với loại điều kiện xếp hạng là hoặc thì Giá trị hoá đơn không thể trùng nhau"
        );
        return false;
      }
    } else {
      //nếu là và thì các thông số số lượng và giá trị không được đồng thời bằng nhau
      const valueLineCountAndTotalArr = dataLine?.map(function (item: any) {
        return `${item.bill_number}-${item.bill_total}`;
      });
      const isDuplicateLineCountAndTotal = valueLineCountAndTotalArr.some(
        function (item: any, idx: any) {
          return valueLineCountAndTotalArr.indexOf(item) != idx;
        }
      );
      if (isDuplicateLineCountAndTotal) {
        toast.warning(
          "Với loại điều kiện xếp hạng là và thì Số lượng hoá đơn và Giá trị hóa đơn không thể đồng thời trùng nhau"
        );
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validationFrom()) return;
    setLoading(true);
    const url = `${baseUrl}/customer-rank-config`;
    const params = {
      ...data,
      review_cycle_day: Number(data?.review_cycle_day),
      review_cycle_maintenance_day: Number(data?.review_cycle_maintenance_day),
      review_cycle_maintenance_day_status:
        data?.review_cycle_maintenance_day_status ? 1 : 0,
      status: data?.status ? 1 : 0,
      customer_rank_config_lines: dataLine?.reduce((prev: any, item: any) => {
        prev = [
          ...prev,
          {
            id: item?.id || undefined,
            rank_name: item?.rank_name,
            bill_number: Number(item?.bill_number || 0),
            bill_total: Number(item?.bill_total || 0),
          },
        ];
        return prev;
      }, []),
    };
    let response: any = await APIClient.PUT(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Cập nhật phân hạng thành viên thành công");
      loadData();
    }
  };

  const handleActionModal = (item: any) => {
    setAction(item);
    setIsOpen(true);
  };

  return (
    <div style={{ paddingBottom: 50 }}>
      <React.Fragment>
        <PageTitle
          breadCrumbItems={[{ label: `Phân hạng thành viên`, active: true }]}
          title={`Phân hạng thành viên`}
        />
        <PageContent>
          <Row>
            <Col md={7} xs={12}>
              <PageBody>
                <div style={{ display: "flex" }}>
                  <ToggleButton
                    elmChecked={data?.status == 0 ? true : false}
                    setData={(val: any) => {
                      setData({
                        ...data,
                        status: val?.status === 1 ? 0 : 1,
                      });
                    }}
                    name="status"
                  />
                  <span className="ml-2">Khoá chức năng hạng thành viên</span>
                </div>
              </PageBody>
              <PageBody>
                <div
                  className="mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="nutri-title">Cấu hình hạng thành viên</div>
                </div>
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup className="nutri-form">
                      <Label
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div className="mr-2">
                          <span className="text-danger">*</span> Chu kì xét hạng
                          thành viên (ngày)
                        </div>
                        <div data-for="rank-tooltip" data-tip>
                          <img src={IconTooltip} width={16} alt="icon" />
                        </div>
                      </Label>
                      <NumberFormat
                        onChange={(e: any) => {
                          let value = TextUtils.onlyNumber(e.target.value);
                          handleChangeInput({
                            target: { name: "review_cycle_day", value: value },
                          });
                        }}
                        name={"review_cycle_day"}
                        type={"text"}
                        className="mt-3 form-control"
                        value={
                          !data?.review_cycle_day
                            ? "---"
                            : data?.review_cycle_day
                        }
                        placeholder={"Nhập giá trị..."}
                        thousandSeparator={true}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup className="nutri-form">
                      <div
                        className="nutri-checkbox"
                        onClick={() =>
                          handleChangeInput({
                            target: {
                              name: "review_cycle_maintenance_day_status",
                              value: data?.review_cycle_maintenance_day_status
                                ? false
                                : true,
                            },
                          })
                        }
                      >
                        <div className="icon">
                          {data?.review_cycle_maintenance_day_status ? (
                            <img src={IconCheckboxActive} alt="icon" />
                          ) : (
                            <img src={IconCheckbox} alt="icon" />
                          )}
                        </div>
                        <Label
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="mr-2 ml-2">
                            Thời hạn duy trì hạng (ngày)
                          </div>
                          <div data-for="tooltip" data-tip>
                            <img src={IconTooltip} width={16} alt="icon" />
                          </div>
                        </Label>
                      </div>
                      <NumberFormat
                        onChange={(e: any) => {
                          let value = TextUtils.onlyNumber(e.target.value);
                          handleChangeInput({
                            target: {
                              name: "review_cycle_maintenance_day",
                              value: value,
                            },
                          });
                        }}
                        name={"review_cycle_maintenance_day"}
                        type={"text"}
                        className="form-control"
                        value={
                          !data?.review_cycle_maintenance_day
                            ? "---"
                            : data?.review_cycle_maintenance_day
                        }
                        placeholder={"Nhập giá trị..."}
                        thousandSeparator={true}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </PageBody>
              <PageBody>
                <div
                  className="mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="nutri-title">Cấp bậc xếp hạng thành viên</div>
                </div>
                <FormGroup className="nutri-form">
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Label>
                        <span>*</span> Loại điều kiện xếp hạng:
                      </Label>
                      <div
                        className={
                          data?.rank_type == "or"
                            ? "ml-3 nutri-radio active"
                            : "ml-3 nutri-radio"
                        }
                        onClick={() => setData({ ...data, rank_type: "or" })}
                      >
                        <div className="icon"></div>
                        <div className="label">Hoặc</div>
                      </div>
                      <div
                        className={
                          data?.rank_type == "and"
                            ? "ml-3 nutri-radio active"
                            : "ml-3 nutri-radio"
                        }
                        onClick={() => setData({ ...data, rank_type: "and" })}
                      >
                        <div className="icon"></div>
                        <div className="label">Và</div>
                      </div>
                    </div>
                  </div>
                </FormGroup>
                <DataTableList
                  user={props?.user}
                  data={dataLine}
                  setData={setDataLine}
                  loading={loading}
                />
              </PageBody>
            </Col>
            <Col md={5} xs={12}>
              <History
                history={history}
                handleActionModal={(data: any) => handleActionModal(data)}
              />
              {/* <PageBody>
                                <div className="mb-3" style={{display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
                                    <div className="nutri-title">Lịch sử thao tác</div>
                                </div>
                            </PageBody> */}
            </Col>
          </Row>
        </PageContent>
        <div className="bottom-action">
          <Button
            color="success"
            className="success-bland ml-2"
            onClick={() => router?.goBack()}
          >
            Đóng
          </Button>
          <Button color="success" className="ml-2" onClick={handleSubmit}>
            Xác nhận
          </Button>
        </div>
        <ReactTooltip id="rank-tooltip" type="info">
          <b>Chu kì xét hạng:</b> <br />
          Vào 24:00 mỗi ngày, hệ thống sẽ tính toán điều kiện trong khoảng thời gian được thiết lập.
        </ReactTooltip>
        <ReactTooltip id="tooltip" type="info" aria-haspopup="true">
          <b>Thời hạn duy trì hạng: </b> <br />
          - Chọn để thiết lập khoảng thời gian duy trì hạng cho khách hàng.
          <br />- Không chọn để luôn duy trì hạng cho tới khi đạt điều kiện mới.
        </ReactTooltip>
        {loading && <Loader />}
      </React.Fragment>
      <ModalPopup isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <RenderActionModal
          {...props}
          closeModal={() => setIsOpen(false)}
          loadData={() => loadData()}
          action={action}
        />
      </ModalPopup>
    </div>
  );
};

const DataTableList = (props: any) => {
  const { data, setData, loading, onlyView } = props;

  const handleLineAdd = () => {
    const newLine = {
      rank_name: "",
      bill_number: 0,
      bill_total: 0,
    };
    setData && setData([...data, newLine]);
  };

  const handleLineUpdate = (dataDetail: any, index: number) => {
    data[index] = dataDetail;
    setData && setData(data);
  };

  const handleLineRemove = (index: number) => {
    let newLine = cloneDeep(data);
    newLine.splice(index, 1);
    setData(newLine);
  };

  const RenderHeadData = () => {
    return (
      <thead>
        <tr>
          <th>
            <span className="require">*</span> Hạng thành viên
          </th>
          <th style={{ width: "22%" }}>Số lượng hoá đơn</th>
          <th style={{ width: "22%" }}>Giá trị hoá đơn</th>
          {!onlyView && <th style={{ width: "15%" }}>Thao tác</th>}
        </tr>
      </thead>
    );
  };

  const RenderBobyData = () => {
    if (data?.length === 0) {
      return <RowEmpty column={4} title="Chưa có cấp bậc nào được cấu hình" />;
    }
    return (
      <tbody>
        {data &&
          data?.length > 0 &&
          data?.map((item: any, index: number) => (
            <LineItem
              detailIndex={index}
              data={item}
              onChangeData={(dataDetail: any) =>
                handleLineUpdate(dataDetail, index)
              }
              handleRemoveData={() => handleLineRemove(index)}
              onlyView={onlyView}
            />
          ))}
      </tbody>
    );
  };

  return (
    <div>
      <Table className="mb-0 table-custom" responsive>
        <RenderHeadData />
        <RenderBobyData />
      </Table>
      {setData && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            onClick={handleLineAdd}
            className="select-menu-add"
            style={{
              border: "none",
            }}
          >
            <i className="uil-plus"></i> Thêm hạng
          </div>
        </div>
      )}
    </div>
  );
};

const LineItem = (props: any) => {
  const { detailIndex, onChangeData, handleRemoveData, onlyView } = props;
  const [data, setData] = useState<any>(props?.data);

  const handleChangeData = (event?: any) => {
    const { value, name } = event.target;
    if (name == "name") {
      if (value?.length > 200) return;
    }
    setData({
      ...data,
      [name]: value,
    });
    onChangeData({
      ...data,
      [name]: value,
    });
  };

  return (
    <tr key={detailIndex}>
      <td>
        <Input
          disabled={onlyView}
          type="text"
          value={data?.rank_name}
          onChange={(e: any) => handleChangeData(e)}
          name="rank_name"
          placeholder={"Nhập tên hạng"}
        />
      </td>
      <td>
        <NumberFormat
          disabled={onlyView}
          onChange={(e: any) =>
            handleChangeData({
              target: {
                name: "bill_number",
                value: TextUtils.onlyNumber(e.target.value),
              },
            })
          }
          name={"bill_number"}
          type={"text"}
          className="form-control"
          value={data?.bill_number}
          placeholder={"Nhập giá trị..."}
          thousandSeparator={true}
        />
      </td>
      <td>
        <NumberFormat
          disabled={onlyView}
          onChange={(e: any) =>
            handleChangeData({
              target: {
                name: "bill_total",
                value: TextUtils.onlyNumber(e.target.value),
              },
            })
          }
          name={"bill_total"}
          type={"text"}
          className="form-control"
          value={data?.bill_total}
          placeholder={"Nhập giá trị..."}
          thousandSeparator={true}
        />
      </td>
      {!onlyView && (
        <td>
          <div className="table-action">
            <div className="button-nutri" onClick={handleRemoveData}>
              <i className="uil-trash-alt"></i>
            </div>
          </div>
        </td>
      )}
    </tr>
  );
};

const History = (props: any) => {
  const { history, handleActionModal } = props;

  const HistoryItem = ({ item, itemOld }: any) => {
    if (!itemOld) {
      return (
        <tr>
          {/* <td>
            {item?.created_time
              ? moment(item?.created_time).format("HH:mm DD/MM/YYYY")
              : "---"}
          </td>
          <td>{item?.created_uid?.name || item?.updated_uid?.name}</td> */}
          <td style={{ borderBottom: "none" }}>
            <b
              onClick={() =>
                handleActionModal({ type: "viewHistory", data: item })
              }
              className="text-info"
              style={{ cursor: "pointer" }}
            >
              Khởi tạo
            </b>
          </td>
        </tr>
      );
    } else if (
      item?.updated_uid &&
      item?.status === 1 &&
      itemOld?.status === 0
    ) {
      return (
        <tr>
          {/* <td>
            {item?.updated_time
              ? moment(item?.updated_time).format("HH:mm DD/MM/YYYY")
              : "---"}
          </td>
          <td>{item?.updated_uid?.name}</td> */}
          <td style={{ borderBottom: "none" }}>Mở khoá chức năng HTV</td>
        </tr>
      );
    } else if (
      item?.updated_uid &&
      item?.status === 0 &&
      itemOld?.status === 1
    ) {
      return (
        <tr>
          {/* <td>
            {item?.updated_time
              ? moment(item?.updated_time).format("HH:mm DD/MM/YYYY")
              : "---"}
          </td>
          <td>{item?.updated_uid?.name}</td> */}
          <td>Khoá chức năng HTV</td>
        </tr>
      );
    } else if (item?.updated_uid) {
      return (
        <tr>
          {/* <td>
            {item?.updated_time
              ? moment(item?.updated_time).format("HH:mm DD/MM/YYYY")
              : "---"}
          </td>
          <td>{item?.updated_uid?.name}</td> */}
          <td style={{ borderBottom: "none" }}>
            <b
              onClick={() =>
                handleActionModal({ type: "viewHistory", data: item })
              }
              className="text-info"
              style={{ cursor: "pointer" }}
            >
              Chỉnh sửa
            </b>
          </td>
        </tr>
      );
    }
    return (
      <tr>
        {/* <td>
          {item?.created_time
            ? moment(item?.created_time).format("HH:mm DD/MM/YYYY")
            : "---"}
        </td>
        <td>{item?.created_uid?.name || item?.updated_uid?.name}</td> */}
        <td>
          <b
            onClick={() =>
              handleActionModal({ type: "viewHistory", data: item })
            }
            className="text-info"
            style={{ cursor: "pointer" }}
          >
            Khởi tạo
          </b>
        </td>
      </tr>
    );
  };
  const _ = require("lodash");
  const columns = [
    {
      dataField: "created_time",
      text: "Thời gian",
      formatter: (item: any) => {
        return (
          <p style={{ marginTop: "15px" }}>
            {item ? moment(item).format("HH:mm DD/MM/YYYY") : "---"}
          </p>
        );
      },
    },
    {
      dataField: "updated_uid.name",
      text: "Người thực hiện",
    },
    {
      dataField: "created_uid",
      text: "Hành động",
      formatter: (value: any, item: any) => {
        let findLastIndex = _.findIndex(history, (e: any) => {
          return e.id == item.id;
        });
        const itemOld = history[findLastIndex + 1];

        return <HistoryItem item={item} itemOld={itemOld} />;
      },
    },
  ];

  const options = {
    custom: true,
    totalSize: history?.length || 0,
    sizePerPage: 4
  };

  return (
    <PageBody>
      <div className="nutri-title mb-3">Lịch sử thao tác</div>
      <div className="table-responsive" style={{ overflow: "unset" }}>
        <table className="mb-0 table-custom no-bg table table-input">
          <PaginationProvider pagination={paginationFactory(options)}>
            {({ paginationProps, paginationTableProps }) => (
              <div>
                <BootstrapTable
                  keyField="id"
                  data={history || []}
                  columns={columns}
                  {...paginationTableProps}
                />
                <PaginationListStandalone {...paginationProps} />
              </div>
            )}
          </PaginationProvider>
        </table>
      </div>
    </PageBody>
  );
};

const RenderActionModal = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(props?.action?.data);
  const [dataLine, setDataLine] = useState(
    props?.action?.data?.customer_rank_config_lines_log
  );
  const { closeModal, action, loadData } = props;
  const onlyView = action?.type === "view";

  useEffect(() => {
    setData(props?.action?.data);
    setDataLine(props?.action?.data?.customer_rank_config_lines_log);
  }, [props?.action]);

  return (
    <CardBody
      className="p-0"
      style={{ width: action?.type === "viewHistory" ? 1000 : 500 }}
    >
      <div className="modal-header">
        <h5 className="modal-title" id="modal-action-title">
          {action?.type === "viewHistory" &&
            "Chi tiết cấu hình hạng thành viên"}
        </h5>
        <button onClick={() => closeModal()} type="button" className="close">
          {" "}
          <span aria-hidden="true">×</span>{" "}
        </button>
      </div>
      <div className="modal-body p-4">
        {action?.type === "viewHistory" && (
          <>
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="nutri-title">Cấu hình hạng thành viên</div>
            </div>
            <Row>
              <Col md={3} xs={12}>
                <FormGroup className="nutri-form">
                  <Label
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div className="mr-2">
                      <span className="text-danger">*</span> Chu kì xét hạng
                      thành viên (ngày)
                    </div>
                    <div
                      data-for="rank-tooltip"
                      data-tip={
                        "Chu kỳ xét hạng là khoảng thời gian để hệ thống tính toán điều kiện xếp hạng"
                      }
                    >
                      <img src={IconTooltip} width={16} alt="icon" />
                    </div>
                  </Label>
                  <ValueText>
                    {!data?.review_cycle_day
                      ? "---"
                      : PriceUtils.format(data?.review_cycle_day, "")}
                  </ValueText>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <FormGroup className="nutri-form">
                  <div className="nutri-checkbox">
                    <div className="icon">
                      {data?.review_cycle_maintenance_day_status ? (
                        <img src={IconCheckboxActive} alt="icon" />
                      ) : (
                        <img src={IconCheckbox} alt="icon" />
                      )}
                    </div>
                    <Label
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div className="mr-2 ml-2">
                        Thời hạn duy trì hạng (ngày)
                      </div>
                      <div
                        data-for="rank-tooltip"
                        data-tip={
                          "Thời hạn duy trì hạng là khoảng thời gian khách hàng được giữ nguyên hạng sau khi ở nột hạng mới"
                        }
                      >
                        <img src={IconTooltip} width={16} alt="icon" />
                      </div>
                    </Label>
                  </div>
                  <ValueText>
                    {!data?.review_cycle_maintenance_day
                      ? "---"
                      : PriceUtils.format(
                          data?.review_cycle_maintenance_day,
                          ""
                        )}
                  </ValueText>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <FormGroup className="nutri-form">
                  <div className="nutri-checkbox">
                    <Label
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div className="mr-2 ml-2">Thời gian thao tác</div>
                    </Label>
                  </div>
                  <ValueText>
                    {data?.updated_time
                      ? moment(data?.updated_time).format("HH:mm DD/MM/YYYY")
                      : "---"}
                  </ValueText>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <FormGroup className="nutri-form">
                  <div className="nutri-checkbox">
                    <Label
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div className="mr-2 ml-2">Người thao tác</div>
                    </Label>
                  </div>
                  <ValueText>
                    {data?.created_uid?.name || data?.updated_uid?.name}
                  </ValueText>
                </FormGroup>
              </Col>
            </Row>
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="nutri-title">Cấp bậc xếp hạng thành viên</div>
            </div>
            <FormGroup className="nutri-form">
              <div className="d-flex align-items-center">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Label>
                    <span>*</span> Loại điều kiện xếp hạng:
                  </Label>
                  <div
                    className={
                      data?.rank_type == "or"
                        ? "ml-3 nutri-radio active"
                        : "ml-3 nutri-radio"
                    }
                  >
                    <div className="icon"></div>
                    <div className="label">Hoặc</div>
                  </div>
                  <div
                    className={
                      data?.rank_type == "and"
                        ? "ml-3 nutri-radio active"
                        : "ml-3 nutri-radio"
                    }
                  >
                    <div className="icon"></div>
                    <div className="label">Và</div>
                  </div>
                </div>
              </div>
            </FormGroup>
            <DataTableList
              user={props?.user}
              data={dataLine}
              loading={loading}
              onlyView={true}
            />
          </>
        )}
      </div>
      {loading && <Loader />}
    </CardBody>
  );
};

const mapState = (state: any) => {
  return {
    user: state.Auth.user,
  };
};

const PageContent = styled.div`
  &.only-view {
    .nutri-form {
      input {
        border: none;
        pointer-events: none;
      }
      .react-select__indicators {
        display: none !important;
      }
      .react-select__control {
        border: none;
        background-color: transparent !important;
      }
    }
  }
`;

export default connect(mapState)(RankConfig);
